import { Component } from '@angular/core';
import { Router } from '@angular/router';

// CAESAR – jogi ügykezelő burok. A fő headerben dinamikusan mutatjuk, hol vagyunk
// (CAESAR · oldalnév). A felső szegmens-sáv redundáns a bal oldali menüvel, ezért
// alapból REJTETT; a felhasználó a fejléc gombjával visszakapcsolhatja.
@Component({
  selector: 'app-caesar-layout',
  templateUrl: './caesar-layout.component.html',
  styleUrls: ['./caesar-layout.component.scss'],
})
export class CaesarLayoutComponent {
  felsoMenu = localStorage.getItem('caesarFelsoMenu') === '1';

  constructor(public router: Router) {}

  felsoMenuValt() {
    this.felsoMenu = !this.felsoMenu;
    localStorage.setItem('caesarFelsoMenu', this.felsoMenu ? '1' : '0');
  }

  // szegmens-azonosító → megjelenő oldalnév (a fő headerben mutatjuk, hol vagyunk)
  private static readonly CIMEK: Record<string, string> = {
    ugyek: 'Ügyek', teendok: 'Teendők', iktato: 'Iktató', riportok: 'Riportok',
    szemelyek: 'Személyek', sablonok: 'Sablonok', ugytipusok: 'Ügytípusok', beallitasok: 'Beállítások',
  };

  aktivSzegmens(): string {
    const u = this.router.url;
    if (u.startsWith('/caesar/teendok')) return 'teendok';
    if (u.startsWith('/caesar/iktato')) return 'iktato';
    if (u.startsWith('/caesar/riportok')) return 'riportok';
    if (u.startsWith('/caesar/szemelyek')) return 'szemelyek';
    if (u.startsWith('/caesar/sablonok')) return 'sablonok';
    if (u.startsWith('/caesar/ugytipusok')) return 'ugytipusok';
    if (u.startsWith('/caesar/beallitasok')) return 'beallitasok';
    return 'ugyek';
  }

  // A fő headerben megjelenő oldalnév (hol vagyunk a CAESAR rendszeren belül).
  oldalCim(): string {
    if (this.router.url.startsWith('/caesar/ugy/')) return 'Ügy részletei';
    return CaesarLayoutComponent.CIMEK[this.aktivSzegmens()] || 'Jogi ügykezelő';
  }

  open(url: string) {
    this.router.navigateByUrl(url);
  }
}
